import { getCsrfValue } from "~/common/utils/ApiHelper";
import { getOccTransport } from "~/common/api/occTransport";

interface UpdateGuestCheckoutFormData {
  firstName: string;
  lastName: string;
  companyName: string;
  email: string;
  phone: string;
  line1: string;
  line2: string;
  zipCode: string;
  city: string;
  country: string;
  salutationCode?: string;
  titleCode?: string;
}

export function submitGuestCheckoutForm(cartId: string, data: UpdateGuestCheckoutFormData, signal?: AbortSignal) {
  const { request, baseSiteUrl, userPath } = getOccTransport();
  return request(
    baseSiteUrl(`${userPath()}/carts/${encodeURIComponent(cartId)}/guest-checkout`),
    {
      method: "POST",
      headers: {
        "content-type": "application/json",
        CSRFToken: getCsrfValue(),
      },
      redirect: "follow",
      body: JSON.stringify(data),
      signal,
    },
    { accountContext: "omit" },
  );
}
